module.exports = __webpack_public_path__ + "static/fonts/Nunito-MediumItalic.7f76e55.woff2";